import AccessibilityHelper from '../../00_utilities/helpers/AccessibilityHelper';
import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';

class Details {
    constructor(elem) {
        this.elem = elem;
        this.toggleId = this.elem.getAttribute('data-toggle');
        this.toggle = this.toggleId ? document.getElementById(this.toggleId) : null;
        this.label = this.toggleId ? this.elem.querySelector(`[for='${this.toggleId}'`) : null;
        this.labelText = this.label ? this.label.querySelector('.details__toggle-text') : null;
        this.boundToggleListener = this.toggleItem.bind(this);
    }

    init() {
        if (this.toggle) {
            AccessibilityHelper.addAndHandleLabelsToggle('checkbox', this.toggle);
            this.toggle.addEventListener('change', this.boundToggleListener);
            this.handleResize();
        }
    }

    toggleItem(event) {
        const toggleInput = event.currentTarget;

        this.toggleText(toggleInput);

        if (toggleInput.checked) {
            this.openItem(toggleInput, this.elem);

            return;
        }

        this.closeItem(toggleInput);
    }

    toggleText(input) {
        if (this.label && this.labelText) {
            let text = this.label.getAttribute('data-label-open');

            if (input.checked) {
                text = this.label.getAttribute('data-label-close');
            }

            this.labelText.innerHTML = text;
        }
    }

    openItem(toggle, item) {
        const maxHeight = item.scrollHeight;
        this.elem.style.setProperty('--details-max-height', `${maxHeight}px`);
        toggle.setAttribute('checked', 'checked');
    }

    closeItem(toggle) {
        if (toggle) {
            toggle.checked = false;
        }

        this.elem.style.setProperty('--details-max-height', 0);
    }

    setMenuMaxHeight() {
        const elementContent = this.elem;

        if (elementContent) {
            const maxHeight = elementContent.scrollHeight;
            this.elem.style.setProperty('--details-max-height', `${maxHeight}px`);
        }
    }

    handleResize() {
        window.addEventListener('resize', GeneralHelper.throttle(() => {
            if (this.toggle.checked) {
                this.setMenuMaxHeight();
            }
        }, 200));
    }
}

export default Details;
